import script from "./dailyProductReport.vue?vue&type=script&setup=true&lang=js"
export * from "./dailyProductReport.vue?vue&type=script&setup=true&lang=js"

import "./dailyProductReport.vue?vue&type=style&index=0&id=23b428d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b428d0"]])

export default __exports__